/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgShare2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M18 2.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-2.796 4.749a3.75 3.75 0 10-.756-1.295L8.795 9.5a3.75 3.75 0 100 4.997l5.653 3.294a3.75 3.75 0 10.758-1.294l-5.654-3.295c.128-.378.197-.782.197-1.203 0-.42-.07-.826-.197-1.203l5.65-3.298zm-7.286 3.324a.736.736 0 00.052.089c.178.322.28.693.28 1.088a2.24 2.24 0 01-.332 1.177 2.25 2.25 0 110-2.354zm8.086 7.138a.76.76 0 00.112-.192 2.25 2.25 0 11-.113.192z'
      />
    </svg>
  );
}

export default SvgShare2;
